import { Button, Form, Modal } from 'react-bootstrap'

type Values = {
  name: string
}

type Props = {
  values: Values
  handleSubmit: React.SubmitEventHandler<HTMLFormElement>
  fetching: boolean
  title: string
  submitButtonText: string
  onClickCancel: () => void
}

export const DeleteArticleRulesGroupForm = ({
  values,
  handleSubmit,
  fetching,
  title,
  submitButtonText,
  onClickCancel
}: Props) => (
  <>
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Form noValidate onSubmit={handleSubmit}>
      <Modal.Body>
        <p>以下の組版ルールグループを削除します。よろしいですか？</p>
        <p>組版ルールグループ名称：{values.name}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClickCancel}>
          キャンセル
        </Button>
        <Button type='submit' disabled={fetching}>
          {submitButtonText}{' '}
        </Button>
      </Modal.Footer>
    </Form>
  </>
)
